<template>
  <nav class="ins-tabs">
    <a
      v-for="t in tabs"
      :key="t.id"
      href="javascript:void(0)"
      :class="{ active: value === t.id }"
      @click="$emit('input', t.id)"
    >{{ t.label }}</a>
  </nav>
</template>

<script>
/* Shared tab bar. tabs: [{ id, label }]. v-model via `value` + `input`. A report that lazy-loads
 * (e.g. Manufacturing Insights) can listen to @input and trigger its own load-on-first-show. */
export default {
  name: "InsTabs",
  props: {
    tabs: { type: Array, default: () => [] },
    value: { type: String, default: "" },
  },
};
</script>
